import { getWidthBlock } from '../getWidthBlock'

export const styles = () => ({
  templateImg: {
    animation: '.5s messageImageAnimation',
    borderRadius: 10,
    display: 'block',
    position: 'relative',
    cursor: 'zoom-in',
    height: 140,
  },
  templateImgSpinnerContainer: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: -1,
  },
})

export const templateImgStyle = (device, url, received) => ({
  width: getWidthBlock(device),
  backgroundImage: `url('${url}')`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
  marginRight: received ? '' : '10px',
})
